var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2002 5.5333C16.1002 4.62497 15.3919 3.92498 14.4919 3.82498L10.3002 3.35831C9.7002 3.29165 9.13354 3.49996 8.71687 3.91663L2.2752 10.3583C1.59186 11.0417 1.59186 12.15 2.2752 12.825L7.2002 17.75C7.54186 18.0917 7.99186 18.2583 8.43353 18.2583C8.87519 18.2583 9.3252 18.0917 9.66687 17.75L16.1085 11.3083C16.5252 10.8916 16.7252 10.3167 16.6669 9.72499L16.2002 5.5333ZM14.9335 10.125L8.49187 16.5666C8.49187 16.5666 8.40853 16.6 8.38353 16.5666L3.45853 11.6416C3.45853 11.6416 3.42519 11.5583 3.45853 11.525L9.89186 5.09166C9.94186 5.04166 10.0169 5.0083 10.0835 5.0083C10.0919 5.0083 10.1002 5.0083 10.1169 5.0083L14.3085 5.47496C14.4335 5.49163 14.5335 5.58333 14.5502 5.71666L15.0169 9.9083C15.0252 9.99163 15.0002 10.075 14.9419 10.1333L14.9335 10.125Z",
    fill: "#1E293B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8084 6.875C11.0834 6.875 10.4917 7.46663 10.4917 8.19163C10.4917 8.91663 11.0834 9.50831 11.8084 9.50831C12.5334 9.50831 13.125 8.91663 13.125 8.19163C13.125 7.46663 12.5334 6.875 11.8084 6.875Z",
    fill: "#1E293B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.6994cb770baa22ca71d22dc77a43f0c7.svg";
export { ForwardRef as ReactComponent };